import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function MotDePasseOublie() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [envoye, setEnvoye] = useState(false)
  const [erreur, setErreur] = useState('')

  const envoyer = async (e) => {
    e.preventDefault()
    setLoading(true)
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/nouveau-mot-de-passe`
    })
    setLoading(false)
    if (error) return setErreur('Erreur. Vérifie l\'adresse email.')
    setEnvoye(true)
  }

  return (
    <div style={containerStyle}>
      <div className="card fade-in" style={{ maxWidth: 440, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <span style={{ fontSize: 48 }}>🔑</span>
          <h1 style={titreStyle}>Mot de passe oublié</h1>
        </div>

        {envoye ? (
          <div>
            <div style={{ background: '#F0FDF4', borderRadius: 12, padding: '16px', textAlign: 'center', marginBottom: 20 }}>
              <p style={{ color: '#166534', fontWeight: 700 }}>📬 Email envoyé ! Vérifie ta boîte mail.</p>
            </div>
            <Link to="/connexion" className="btn" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
              Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={envoyer} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <p style={{ color: '#6B7280', fontSize: 14, lineHeight: 1.6 }}>
              Saisis ton adresse email et on t'envoie un lien pour réinitialiser ton mot de passe.
            </p>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
              className="input" placeholder="ton@email.com" />
            {erreur && <div style={{ color: '#DC2626', fontSize: 13, fontWeight: 700 }}>{erreur}</div>}
            <button type="submit" className="btn" disabled={loading} style={{ width: '100%' }}>
              {loading ? 'Envoi...' : 'Envoyer le lien'}
            </button>
            <Link to="/connexion" style={{ textAlign: 'center', color: '#7C3AED', fontSize: 14, fontWeight: 700 }}>
              ← Retour
            </Link>
          </form>
        )}
      </div>
    </div>
  )
}

const containerStyle = {
  minHeight: '100vh', background: 'linear-gradient(135deg, #7C3AED 0%, #5B21B6 60%, #F59E0B 100%)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
}
const titreStyle = { fontFamily: "'Baloo 2', cursive", fontSize: 26, fontWeight: 900, color: '#1E1B4B', textAlign: 'center', marginTop: 8 }
